/// <reference types="@angular/localize" />
/// <reference types="@types/google.maps" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLicense } from '@syncfusion/ej2-base';
import { Environment } from '@environment/environment';
import { EnvironmentNames } from '@environment/environment.enum';

// Registering Syncfusion license key
registerLicense('ORg4AjUWIQA/Gnt2VVhkQlFadVdJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxQdkZjW39bdX1QQ2ZdUkM=');

bootstrapApplication(AppComponent, appConfig).then(async () => {
  // if(Environment.environment !== EnvironmentNames.local) {
  //   if ('serviceWorker' in navigator) {
  //    await  navigator.serviceWorker.register('/ngsw-worker.js');
  //   }
  // }
})
  .catch((err) => console.error(err));
